<template>
  <div class="knowledgebase">
    <div class="row preFilterBlk">
      <div class="px-3 d-inline-flex flex-wrap">
        <div
          class="pr-3"
          v-if="
            this.$GVO.my_profile.Support == 1 || this.$GVO.my_profile.adm == 1
          "
        >
          <button class="btn btn-simple btn-primary" @click="goToPosts()">
            Настроить базу знаний
          </button>
        </div>
      </div>
    </div>

    <tabs
      type="primary"
      tabContentClasses="tab-opt"
      centered
      inline
      round
      :activeTab="currentTab"
      @change="OnTabChange"
      class="card card-plain"
    >
      <tab-pane
        :id="KBase.class_name"
        :key="KBase.class_name"
        v-for="KBase in arrKBases"
      >
        <span slot="label" class="tab-label">
          <i class="tab-icon tim-icons icon-paper"></i>
          <span>{{ KBase.description }}</span>
        </span>
        <div>
          <h3
            class="d-md-flex d-lg-none justify-content-center text-center mb-3"
          >
            {{ KBase.description }}
          </h3>
          <div class="row px-3">
            <ReCardKBPostNest :kb_group="KBase.class_name" />
          </div>
        </div>
      </tab-pane>
    </tabs>
  </div>
</template>

<script>
import ReCardKBPostNest from "src/our_components/knowledgebase/ReCardKBPostNest.vue";
import { TabPane, Tabs } from "src/components";

export default {
  name: "KnowledgeBase-page",
  components: {
    TabPane,
    Tabs,
    ReCardKBPostNest,
  },
  data() {
    return {
      ApiData: [],
      arrKBases: [],
      currentTab: "KB_MAIN",
      strCurTab: "KB_MAIN",
    };
  },
  computed: {},
  methods: {
    goToPosts() {
      this.$router.push({
        path: "/data/knowledgebase/posts/" + this.strCurTab,
      });
    },
    getKBases() {
      this.$GVO
        .ApiCall(`KB_MAIN.getKBases`, {})
        .then((objApi) => {
          this.arrKBases = objApi.data;
        })
        .catch((errorObjApi) => console.error(errorObjApi));
    },
    OnTabChange(strTabId) {
      this.strCurTab = strTabId;
      //this.GetRestr();
    },
  },
  created() {
    this.getKBases();
  },
  mounted() {},
};
</script>
<style scoped>
.preFilterBlk {
  align-items: baseline;
  margin-top: 20px;
  justify-content: space-between;
}
.knowledgebase >>> .nav-pills .nav-item .nav-link {
  padding: 1px 23px;
  min-width: 80px;
}

@media (max-width: 576px) {
  .preFilterBlk .d-flex {
    flex-direction: column;
    margin-bottom: 10px;
  }
  .filter-tag-row {
    padding: 0 15px;
  }
}
</style>
